import { render } from "./ConfirmBox.vue?vue&type=template&id=05daba00"
import script from "./ConfirmBox.vue?vue&type=script&lang=js"
export * from "./ConfirmBox.vue?vue&type=script&lang=js"

import exportComponent from "/home/hoxer/Dokumenter/GitHub/techecute/pwa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QAvatar,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
